import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useInView } from "react-intersection-observer";
import { TextLink } from "@vds/buttons";
import { Checkbox } from '@vds/core';
import { Grid, Row, Col } from "@vds/grids";
import { Modal, ModalBody } from "@vds/modals";
import styled from "styled-components";
import { ColorSwatch } from "../";
import { getStartsAtPrice, getDefaultSku } from "../../../utils/pdpUtils";
import { useTranslation } from "react-i18next";
import { useImageUtils } from "hooks";
import { MarginSpacerM, MarginSpacerXS } from "../styleTag";
import {
  setGWJointOfferSelected,
  setSelectedFeature,
} from "pages/Mobility/ducks/MobilitySlice";
import CountDown from "../CountDown/CountDown";
import { Cap, Badge, Button } from "@vbg-ds/core";
import { Text } from "@vds/core";
import Tag from "@vds/core/icons/tag";
import "./DeviceCard.css";

const DeviceCard = React.memo(function DeviceCard(props) {
  const { ref, inView, entry } = useInView({
    rootMargin: "1000px",
    triggerOnce: false,
  });

  const { t } = useTranslation(["gridwall", "app"]);
  // const showTradeInToggle = t('showTradeInToggle', { ns: "app" });
  const aemContentLabels = t("gridwall.labels", { ns: "gridwall", returnObjects: true });
  const globalData = useSelector((state) => state.GlobalData);
  const showTradeInToggle = globalData?.metaInformation?.tradeinToggle
    ? "Y"
    : "N";
  const [selectedSku, setSelectedSku] = useState({});
  const [deviceOptions, setDeviceOptions] = useState([]);
  const [colorName, setColorName] = useState("");
  const [uniqueColorsList, setUniqueColorsList] = useState([]);
  const [colorsList, setColorList] = useState([]);
  const [colorCount, setColorCount] = useState("");
  const [promo, setPromo] = useState("");
  const [showModal, setShowModal] = useState(false);
  const { getImageLink } = useImageUtils();
  const dpp =
    selectedSku?.pricingDetails?.devicePayments?.length &&
    selectedSku?.pricingDetails?.devicePayments[0];
  const discountAmount =
    showTradeInToggle === "Y" &&
      props?.tradeInToggle &&
      dpp?.tradeInOfferDetails
      ? Number(dpp?.tradeInOfferDetails?.discountAmount)
      : Number(dpp?.offerDetails?.discountAmount);
  const finalPrice = dpp?.finalPrice;
  const dispatch = useDispatch();
  const showAddressModalAgentLink = t("gridwall.enableAddressModalAgentLink", {
    ns: "gridwall",
  });
  const isfromAgentLinkPage = useSelector(
    (state) => state?.GlobalData?.fromAgentLinkDealsPage
  );
  const isfromMyLinkPage = useSelector(
    (state) => state?.GlobalData?.fromMyLinkDealsPage
  );
  const zipCodeFromLearn = useSelector((state) => {
    return (
      state.PlanFirst?.addressFromLearn?.zipCode ??
      state.PlanFirst?.addressFromLearn?.zipCodeVal
    );
  });
  const ineligibleForDpp =
    globalData?.sessionCartData?.apiResponse?.prospectFlowData
      ?.ineligibleForDpp || false;
  const pageData = useSelector((state) => state.MobilityPage);
  const skuNotAvailable = (sku) =>
    sku.outOfStock || sku.preOrder || sku.backOrder;
  let preOrderShimentDate = selectedSku?.shipmentDate?.replace(/\b0/g, "");
  const movePDPAddressModaltoGW =
    isfromAgentLinkPage || isfromMyLinkPage
      ? showAddressModalAgentLink
      : globalData?.metaInformation?.addressModalOnGW;
  const showDateTime =
    selectedSku &&
      selectedSku.iconicDevice &&
      selectedSku.endTimeStampInTargetTimeZone
      ? true
      : false;
  const isMobile = useMediaQuery({
    query: "(max-width: 545px)",
  });

  useEffect(() => {
    const skulist = props?.data?.skulist;
    let deviceOptions = skulist;
    let defaultSkuObj = getDefaultSku(deviceOptions, props.sortBy);
    let defaultProduct =
      defaultSkuObj?.length > 0 &&
      defaultSkuObj[1]?.filter((item) => item.defaultSku == true);
    // Prod defect fix for Smart-watch default Sku
    if (
      defaultProduct === null ||
      defaultProduct === undefined ||
      defaultProduct.length === 0
    ) {
      defaultProduct = [skulist[0]];
    }
    let defaultProductObj = { ...defaultProduct[0], color: colorName };
    let sortedDeviceOptions =
      defaultSkuObj && defaultSkuObj[1] != undefined
        ? defaultSkuObj[1]
        : deviceOptions;
    defaultProduct?.length && setSelectedSku(defaultProductObj);
    setDeviceOptions(sortedDeviceOptions);

    const dppDetail = defaultProduct?.[0]?.pricingDetails?.devicePayments?.[0];

    if (
      Array.isArray(dppDetail?.promoDetails) &&
      dppDetail?.promoDetails?.length
    ) {
      const tradeInDetails = dppDetail?.promoDetails?.filter(
        (i) => i?.promoType === "TRADEIN_PER_MONTH"
      )?.[0];
      const promoDetail =
        showTradeInToggle === "Y" &&
          props?.tradeInToggle &&
          dppDetail?.tradeInOfferDetails
          ? tradeInDetails
            ? tradeInDetails?.promoMessages
            : []
          : dppDetail.promoDetails[0].promoMessages;
      if (Array.isArray(promoDetail) && promoDetail?.length) {
        setPromo({
          header: promoDetail[0]?.badgeText,
          tooltipText: promoDetail[1] && promoDetail[1]?.badgeText,
          modalContentUrl: promoDetail[1] && promoDetail[1]?.badgeToolTipUrl,
        });
      }
    }
  }, [props?.data, props?.tradeInToggle]);

  useEffect(() => {
    let colorsList = getUniqueColors(deviceOptions);
    let limitedColorList =
      colorsList.length > 6 ? colorsList.slice(0, 5) : colorsList.slice(0, 6);
    let colorCount = colorsList.filter(
      (item) => !limitedColorList.includes(item)
    );
    setColorCount(colorCount.length);
    setColorList(colorsList);
    setUniqueColorsList(limitedColorList);
  }, [deviceOptions]);

  const onCardSelect = (e) => {
    if (
      ((!!zipCodeFromLearn || pageData?.zipcodeFromGW || pageData?.zipCode) &&
        !!movePDPAddressModaltoGW) ||
      !movePDPAddressModaltoGW
    ) {
      onCardSelectwithAddress(e);
    } else {
      props?.onChangeRef(true, onCardSelectwithAddress, e);
      props?.setForDeviceCard(true);
      props?.setShowNewCustomerModal(true);
    }
    dispatch(setSelectedFeature(""));
  };

  const onCardSelectwithAddress = (e) => {
    if (e?.target) {
      for (const cls of e?.target?.classList) {
        // ignore elements of modal
        if (cls.startsWith("IconWrapper") || cls.startsWith("Overlay")) {
          return;
        }
      }
    }

    if (
      (e?.target?.nodeName !== "circle" &&
        e?.target?.nodeName !== "line" &&
        e?.target?.nodeName !== "SPAN") ||
      !e?.target
    ) {
      !!props?.onClickHandler &&
        props.onClickHandler(
          props.data.seoUrlName,
          props.data.deviceId,
          selectedSku,
          props.data?.category
        );
      if (!pageData?.bundleOfferSelected) {
        dispatch(setGWJointOfferSelected(false));
      }
    }
  };

  const onCompareSelect = () => {
    let sel = { ...props.data };
    delete sel["skulist"];
    sel.selectedSku = selectedSku;
    props?.onCompareSelect && props.onCompareSelect(sel);
  };

  const getUniqueColors = (list) => {
    const colors = new Map();
    list.forEach((sku, index) => {
      const existing = colors.get(sku.cssColor);
      if (!existing || skuNotAvailable(existing)) {
        colors.set(sku.cssColor, {
          index: index,
          cssColor: sku.cssColor,
          skuId: sku.sku,
          outOfStock: sku.outOfStock,
          defaultSku: sku.defaultSku,
        });
      }
    });
    return Array.from(colors.values());
  };

  const getDisplayPrice = (sku) => {
    const price = getStartsAtPrice(
      sku,
      props?.tradeInToggle,
      showTradeInToggle
    );
    return (
      "$" +
      t("gridwall.labels.deviceFinalPrice", {
        ns: "gridwall",
        finalPrice: price,
      })
    );
  };

  const getInstallments = (devicePayments) => {
    const num = (devicePayments && devicePayments?.nofInstallements) ?? 0;
    let text = t("gridwall.labels.deviceFinalPriceInMonths", {
      ns: "gridwall",
      paymentTenure: num,
    }).replaceAll(";", "");
    return text;
  };

  const getRetailPrice = (sku) => {
    const price = Number(sku?.pricingDetails?.zeroYear?.price).toFixed(2);
    return t("gridwall.labels.retailPrice", {
      ns: "gridwall",
      retailPriceZeroYear: `$${isNaN(price) ? 0 : price}`,
    });
  };

  const onMouseOverFun = (e) => {
    setColorName(deviceOptions[e]?.color);
  };

  const onMouseLeaveFun = () => {
    setColorName("");
  };

  return (
    <>
      <DeviceContainer
        ref={ref}
        className="device-card"
        data-track={`${selectedSku?.sku}:${props?.data?.brandName} ${props?.data?.name}`}
        data-sku={`${selectedSku?.sku}`}
        data-click={true}
        onClick={onCardSelect}
      >
        {inView ? (
          <>
            {
              promo && !props.hidePromoBadge ?  
              <CapOffer>
                <Cap
                  backgroundColor="red"
                  bold
                  characterLimit={32}
                  height="48px"
                  width="297px"
                  icon="tag"
                  iconAlignment="middle"
                  maxHeight="48px"
                  renderIcon={(iconProps) => <Tag {...iconProps} />}
                  sidePadding="24px"
                  surface="lightPrimary"
                  // tooltip={{
                  //   size: "small",
                  //   title: "tooltip",
                  // }}
                >
                  {promo?.header} 
                </Cap>
              </CapOffer> :
              <CapOffer><CapOfferText/></CapOffer>
            }
            {/* <Offers>
              {promo && !props.hidePromoBadge && (
                <OfferText>
                  <Text kind="body" size="small" color="#FFFFFF">
                    {promo?.header}
                  </Text>
                </OfferText>
              )}
            </Offers> */}
            <ImageContainer>
              <picture className="image-container">
                <source
                  type="image/webp"
                  srcset={getImageLink(selectedSku?.filePath, 130, 130, true)}
                />
                <DeviceImgContainer>
                  <DevicePicture
                    url={getImageLink(selectedSku?.filePath, 130, 130)}
                  ></DevicePicture>
                </DeviceImgContainer>
              </picture>
            </ImageContainer>
            <SwatchContainer>
              <Swatches>
                {uniqueColorsList?.map((sku) => (
                  <ColorSwatch
                    key={sku.cssColor}
                    cssColor={sku.cssColor}
                    isSelected={
                      !!(
                        selectedSku.sku === sku.skuId ||
                        selectedSku.cssColor === sku.cssColor
                      )
                    }
                    value={sku.index}
                    colorName={colorName}
                    isOutOfStock={sku.outOfStock}
                    onClick={() => {
                      setSelectedSku(deviceOptions[sku.index]);
                    }}
                    onMouseOver={() => onMouseOverFun(sku.index)}
                    onMouseLeave={() => onMouseLeaveFun()}
                    isUniqueColor={true}
                    width={23}
                    height={23}
                  />
                ))}
                <>
                  {colorsList.length > 6 && (
                    <>
                      {" "}
                      <Text color="black" kind="body" size="small">
                        +{colorCount}
                      </Text>
                    </>
                  )}
                </>
              </Swatches>
            </SwatchContainer>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
              }}
            >
              <DeviceDetailsContainer className="device-container">
                {selectedSku.preOrder ? (
                  <ShipmentDate>
                    {selectedSku.outOfStock ? (
                      <OutofStockText>
                        <Badge
                          backgroundColor="orange"
                          id="badge"
                          surface="lightPrimary"
                          borderRadius="2px"
                        >
                          {t("gridwall.labels.outofstock", {
                            ns: "gridwall",
                          })}
                        </Badge>
                      </OutofStockText>
                    ) : (
                      <Badge
                        backgroundColor="white"
                        icon="tag"
                        id="badge"
                        // onClick (tooltip)={function Us(){}}
                        // renderIcon={function Us(){}}
                        surface="lightPrimary"
                        tooltip={{
                          children: `${t("gridwall.labels.preorder-estimated", {
                            ns: "gridwall",
                          })} ${preOrderShimentDate}`,
                        }}
                      >
                        {`${t("gridwall.labels.preorder-date", {
                          ns: "gridwall",
                        })}`}
                      </Badge>
                      // <Text color="#6F7171" kind="body" size="small">
                      //   {`${t("gridwall.labels.preorder-date", {
                      //     ns: "gridwall",
                      //   })} ${preOrderShimentDate}`}
                      // </Text>
                    )}
                  </ShipmentDate>
                ) : (
                  <></>
                )}
                <div>{showDateTime ? (
                  <>
                    <MarginSpacerM />
                    <CountDown
                      toDate={
                        new Date(
                        new Date(
                            selectedSku["endTimeStampInTargetTimeZone"]
                          ) + "UTC"
                        )
                      }
                       preceedingText={t("iconicTimerText", { ns: "app" })}
                    />
                  </>
                ) : (
                  <></>
                )}</div>
                <div
                  style={{
                    display: "flex",
                    gap: "0.5rem",
                    alignItems: "baseline",
                    marginBottom: "0.5rem",
                  }}
                >
                  {aemContentLabels?.showLabel1 && (
                    <Badge
                      backgroundColor="black"
                      id="badge"
                      surface="lightPrimary"
                      borderRadius="2px"
                      maxWidth="6rem"
                    >
                      {aemContentLabels?.label1Text}
                    </Badge>
                  )}
                  {aemContentLabels?.showLabel2 && (
                    <Badge
                      backgroundColor="white"
                      id="badge"
                      surface="lightPrimary"
                      borderRadius="2px"
                      maxWidth="6rem"
                    >
                      {aemContentLabels?.label2Text}
                    </Badge>
                  )}
                  {selectedSku.outOfStock ? (
                    <OutofStockText>
                      <Badge
                        backgroundColor="orange"
                        id="badge"
                        surface="lightPrimary"
                        borderRadius="2px"
                        maxWidth="6rem"
                      >
                        {t("gridwall.labels.outofstock", {
                          ns: "gridwall",
                        })}
                      </Badge>
                    </OutofStockText>
                  ) : (
                    <OutofStockEmptyText />
                  )}
                </div>
                <DeviceTitle isOutOfStock={selectedSku.outOfStock}>
                  <Text color="black" kind="title" size="2xsmall" bold>
                    {props.data?.brandName} {props.data?.name}
                  </Text>
                </DeviceTitle>
                <PricingContainer>
                  {props?.showDPP && !ineligibleForDpp && (
                    <>
                      {!globalData?.IsVBCClearCartClicked && (
                        <PricingInfo>
                          <p
                            style={{
                              margin: 0,
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "4px",
                              paddingBottom: "4px",
                            }}
                          >
                            <Text color="black" kind="body" size="small">
                              {t("gridwall.labels.startsAt", {
                                ns: "gridwall",
                              })}{" "}
                            </Text>
                            {discountAmount >= 0 ? (
                              <>
                                {Number(
                                  getStartsAtPrice(
                                    selectedSku,
                                    props?.tradeInToggle,
                                    showTradeInToggle
                                  )
                                ) !== Number(finalPrice) && (
                                  <>
                                    <Text
                                      color="#716F6D"
                                      kind="body"
                                      size="small"
                                    >
                                      <span className="strikethrough">
                                        ${finalPrice}
                                        {t("gridwall.labels.per-month", {
                                          ns: "gridwall",
                                        })}
                                      </span>
                                    </Text>
                                    <Text
                                      color="black"
                                      kind="body"
                                      size="small"
                                      bold
                                    >
                                      {" "}
                                      {getDisplayPrice(selectedSku)}
                                    </Text>
                                  </>
                                )}
                              </>
                            ) : (
                              <Text color="black" kind="body" size="small" bold>
                                {getDisplayPrice(selectedSku)}
                              </Text>
                            )}
                          </p>
                        </PricingInfo>
                      )}

                      {!selectedSku.outOfStock &&
                        !globalData?.IsVBCClearCartClicked && (
                          <Text color="#716F6D" kind="body" size="small">
                            <PricingInfo>{getInstallments(dpp)}</PricingInfo>
                          </Text>
                        )}
                    </>
                  )}
                  <MarginSpacerXS />

                  <div style={{ display: !isMobile ? "flex" : "" }}>
                    <Text color="#716F6D" kind="body" size="small">
                      {getRetailPrice(selectedSku)}
                    </Text>
                    {Object.keys(promo)?.length > 0 && (
                      <Text color="black" kind="body" size="small">
                        {" "}
                        <TextLinkXS
                          // size="small"
                          // color="black"
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowModal(true);
                          }}
                        >
                          {t("gridwall.labels.details", {
                            ns: "gridwall",
                          })}
                        </TextLinkXS>
                      </Text>
                    )}
                  </div>
                </PricingContainer>
              </DeviceDetailsContainer>
              {!props?.isBogo ? (
                <ActionsContainer onClick={(e) => e.stopPropagation()}>
                  <Button
                    kind="secondary"
                    role="button"
                    size="small"
                    surface="lightPrimary"
                    width={isMobile ? "100%" : "auto"}
                    onClick={onCardSelect}
                  >
                    {"Explore details"}
                  </Button>
                  <CheckboxWrapper>
                    <Checkbox
                      errorText=""
                      children={t("gridwall.labels.compare", {
                        ns: "gridwall",
                      })}
                      surface="lightSecondary"
                      viewportProp="desktop"
                      width="auto"
                      selected={props?.isSelected}
                      onChange={onCompareSelect}
                    ></Checkbox>
                  </CheckboxWrapper>
                </ActionsContainer>
              ) : (
                <>
                  {" "}
                  <Button
                    kind="secondary"
                    role="button"
                    size="small"
                    surface="lightPrimary"
                    width="auto"
                  >
                    View details
                  </Button>
                </>
              )}
            </div>
            {showModal && (
              <DetailsModal
                opened={showModal}
                onOpenedChange={setShowModal}
                className="card-modal"
              >
                <DetailsModalBody className="card-modal-body">
                  <iframe
                    height="100%"
                    width="100%"
                    src={promo?.modalContentUrl}
                  ></iframe>
                </DetailsModalBody>
              </DetailsModal>
            )}
          </>
        ) : null}
      </DeviceContainer>
    </>
  );
});

const Offers = styled.div`
  margin-left: 0px;
  width: 100%;
  height: 44px;
`;
const CapOffer = styled.div`
  width: 100%;
  border-radius: 8px 8px 0 0;
  > div {
    width: 100% !important;
    border-radius: 8px 8px 0 0 !important;
  }
`;
const CapOfferText = styled.div`
  height: 48px;
`;
const OfferText = styled.div`
  width: 100%;
  // background: #000;
  padding: 0.5rem 1rem;
  display: flex;
  margin-bottom: 1rem !important;
  border-radius: 8px 8px 0 0 !important;
  letter-spacing: 0px;
  text-align: left;

  @media (max-width: 767px) {
    margin-bottom: 1rem !important;
    padding: 0.5rem !important;
  }
`;
const ImageContainer = styled.div`
  height: 144px;
  // left: 0px;
  // top: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  // position: relative;
  margin-top: 2rem;
  @media (max-width: 767px) {
    // top: 0px;
    margin-top: 1rem;
    height: 134px;
    img {
      width: 134px !important;
      height: 134px !important;
      left: 13px;
      top: 60px;
    }
  }
`;
const SwatchContainer = styled.div`
  //height:56px;
  // top: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  // position: relative;
  margin-top: 2.625rem;
  @media screen and (min-device-width: 320px) and (max-device-width: 767px) {
    // top: 16px;
    margin-top: 1rem;
  }
`;

const DeviceImgContainer = styled.div`
  position: relative;
  height: 144px;
  width: 144px;
  @media screen and (min-device-width: 320px) and (max-device-width: 767px) {
    width: 134px !important;
    height: 134px !important;
    //   left: 13px;
    //   top: 16px;
    //   position: absolute;
  }
`;

const DevicePicture = styled.div`
  position: relative;
  background-image: ${({ url }) => `url("${url}")`};
  height: 100%;
  width: 100%;
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: left top;
`;

const DeviceDetailsContainer = styled.div`
  // padding: 1rem;
  // padding-top: 0px;
  // position: relative;
  // top: 35px;
  margin-top: 2.125rem;
  @media only screen and (min-width: 767px) {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  @media (max-width: 767px) {
    // position: relative;
    // top: 10px;
    // padding: 5px;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    margin-top: 1rem;
  }
`;

const PricingContainer = styled.div`
  margin-top: 1rem;
  @media screen and (min-device-width: 320px) and (max-device-width: 767px) {
    margin-top: 0.5rem;
  }
`;

const PricingInfo = styled.div``;

const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  @media (min-width: 767px) {
    padding-left: 1rem;
    padding-right: 1rem;
    margin-bottom: 1.5rem;
  }
  @media screen and (max-width: 766px) {
    padding: 12px;
    margin-bottom: 0.75rem;
    display: flex;
    flex-direction: column-reverse;
    gap: 1rem;
    align-items: flex-start;
  }
  @media screen and (max-width: 954px) {
    padding-left: 0.75rem;
    margin-bottom: 0.75rem;
    display: flex;
    flex-direction: column-reverse;
    gap: 1rem;
    align-items: flex-start;
  }
  // [class^="CheckboxWrapper-VDS"] {
  // @media screen and (min-device-width: 320px) and (max-device-width: 767px) {
  // padding-top: 16px;
  // padding-left: 12px;
  // }
  // align-content: center;
  // }
`;

const DeviceTitle = styled.div``;

const Swatches = styled.div`
  // padding-top:1.5rem;
  // padding-bottom:0rem;
  display:flex;
  // position:relative;
  cursor:auto;
  // margin-bottom: 1.5rem;

  > svg {
    width:20px;
    height:20px;
    margin: 0px 8px 0px 0px;
      @media screen and (min-device-width: 320px) and (max-device-width: 767px){
      width:16px;
    height:16px;
      }
  }
  .swatch-icon-tooltip {
    visibility: hidden;
    opacity: 0;
  }

  :hover {
    .swatch-icon-tooltip {
      opacity: 1;
      visibility: visible;
    }
  }

    @media screen and (min-device-width: 320px) and (max-device-width: 767px){
    {
      // padding-top:2rem !important;
    // padding-bottom:3rem !important;
      display:flex;
    }
    
  }
`;

const ShipmentDate = styled.div`
width:230px;
@media (max-width: 767px){
  {
    width:130px;
    margin-top: 3rem;
   // margin-bottom:-2rem;
  }
`;
const OutofStockText = styled.div`
  @media (max-width: 767px){
  {
    margin-top: 4rem;
  }
`;

const OutofStockEmptyText = styled.div`
  min-height: 8px;
`;

const DetailsModal = styled(Modal)`
  padding: 1.25rem;
  width: 560px;
  height: 596px;
  min-height: auto;
  outline: none !important;
  [class^="ChildWrapper-VDS"] {
    height: 98% !important;
  }
  @media only screen and (min-width: 768px) {
    padding: 4rem 2rem;
    > div:first-child {
      overflow: hidden;
      margin-right: 1.5rem;
    }
  }
  > div:first-child {
    overflow: hidden;
  }
  > div {
    padding: 0px !important;

    @media only screen and (max-width: 420px) {
      overflow: auto;
      ::-webkit-scrollbar {
        width: 4px;
        height: 20px;
        background: #d8dada;
        border-radius: 10px;
      }
      ::-webkit-scrollbar-thumb {
        background: #6f7171;
        border-radius: 10px;
      }
    }

    iframe {
      min-height: 250px !important;
      width: 100%;
      border: none !important;

      @media only screen and (max-width: 420px) {
        overflow: auto;
        ::-webkit-scrollbar {
          width: 4px;
          height: 20px;
          background: #d8dada;
          border-radius: 10px;
        }
        ::-webkit-scrollbar-thumb {
          background: #6f7171;
          border-radius: 10px;
        }
      }
    }

    > span {
      height: 100%;
      width: 100%;

      & > div {
        height: 100% !important;

        & > div {
          padding-right: 20px !important;
        }
      }
    }
  }
  @media only screen and (max-width: 767px) {
    position: absolute;
    height: 100vh;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 95vw;
    > div:first-child {
      margin-top: 3rem !important;
    }
    [data-testid="modal-body"] {
      margin-top: 2.5rem !important;
    }
  }

  @media only screen and (max-width: 420px) {
    width: 100vw;
  }
`;
const DetailsModalBody = styled(ModalBody)`
  padding: 0;
  outline: none !important;
  height: 100%;
`;

const TextLinkXS = styled(TextLink)`
  text-decoration: none;
  margin-left: 6px;
  span {
    border-bottom: none !important;
  }
`;

const DeviceContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media screen and (min-width: 601px) and (max-width: 954px) {
    & {
      min-width: ${window.innerWidth / 3 - 30}px !important;
    }
  }
`;


const CheckboxWrapper = styled.div`
  margin-left:6px;
}`;

const CapPlaceholder = styled.div`
  width: 100%;
  height: 48px;
  border-radius: 8px 8px 0 0;
  @media screen and (max-width: 545px) {
    height: 72px;
  }
}`;

export default DeviceCard;
